/**
 * 转场特效 - tv-noise(电视雪花)
 * 2018-10-8
 */

(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(this);
  } else {
      factory(root);
  }
})(this, function (root) {
  // 类构造函数
  function con(scene, option) {
    this.code = option.code || 'TvNoise';
    this.maskEle = $('<div></div>').attr({id: 'maskEle_' + scene.id});
    this.context = null; // canvas对象
  }

  var methods =  {
    init: function (force) {
      this.duration = 1; // 动效持续时间
      this.startAt = 0.5; // 开始时间（场景结束前n秒）

      return this.supr(this.startAt, force).then(function () {
      });
    },
    initDom: function() {
      if(!this.maskEle) return;

      var editor = this.scene.editor;
      // canvas宽高不是样式而是属性，并将canvas放大以减少性能消耗加大噪点，放大后的位置使用position定位
      var canvas = $('<canvas></canvas>').attr({
        width: editor.clientWidth/1.5,
        height: editor.clientHeight/1.5,
      }).css({
        transform: 'scale(1.5)',
        opacity: .5,
        position: 'absolute',
        top: editor.clientHeight/6,
        left: editor.clientWidth/6
        // 'transform-origin': this.scene.editor.clientWidth/3 + 'px 0'
      });

      this.maskEle.css({
        width: editor.clientWidth,
        height: editor.clientHeight,
        background: '#fff'
      }).append(canvas).hide()

      // lottie容器插入播放层的 maskEle 中
      editor.player.maskEle.append(this.maskEle)

      this.context = canvas[0].getContext("2d");

      this.draw(this.context, 0)
    },
    show: function(frame) {
      if(!this.isInit) return;
      this.supr(frame);

      var scene = this.scene,
          editor = scene.editor,
          sEle = scene.element.player; // player层的当前 scene

      // 播放层显示，对应scene显示
      editor.player.ele.show();
      sEle.show();
      
      // 衔接上一个场景页的动画(e.g.前0.5s的动画)
      if (frame <= this.entrance.end) {
        this.showFirst(frame)
      }

      // 本场景页的转场动画(e.g.后0.5s的动画)
      if (this.nexts && frame >= this.exit.start) {
          // 隐藏上一个场景页的遮罩
          this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();
          
          var nexts_ele = this.nexts.element.player; // player层中的下一个场景
          var offFrame = frame - this.exit.start; // 当前帧减去动画开始时的帧(动画的帧)

          // 遮罩层透明度变化（之所以让起到3，是让不透明时间维持一段时间）
          this.maskEle.show().css({
            opacity: this.linear(offFrame, 0, 3, this.totalFrame)
          })
          // 每次调用都会canvas都会随机生成图像
          this.draw(this.context, offFrame/this.frameRate*1000)
          nexts_ele.hide()
      }

      // 动画外的时间
      if (frame > this.entrance.end && frame < this.exit.start) {
        this.showMiddle()
      }
    },
    showNext: function(frame) {
      var _currentFrame = this.startAt * this.frameRate + frame;

      // 详解见上
      this.maskEle.show().css({
        opacity: this.linear(_currentFrame, 3, -3, this.totalFrame)
      })
      this.draw(this.context, _currentFrame/this.frameRate*1000)
    },
    draw: function(context, time) {
      // 重新绘画canvas函数
      var imgData = context.createImageData(context.canvas.width, context.canvas.height);
      var pix = imgData.data;

      for (var i = 0, n = pix.length; i < n; i += 4) {
        //var c = 7 + Math.sin(i/20000 + time/7); // A sine wave of the form sin(ax + bt)
        // 对sin函数表现效果不满意，自己定义一个概率密度函数(pdf)
        var c = 7 - this.pdf(i/20/context.canvas.height, time/7, .6) * 4
          pix[i] = pix[i+1] = pix[i+2] = 40 * Math.random() * c; // Set a random gray
          pix[i+3] = 255; // 100% opaque
      }

      context.putImageData(imgData, 0, 0);
    },
    /**
     * 概率密度函数
     * @param {*} x 相当于x变量
     * @param {*} m x轴上的偏移
     * @param {*} s 控制峰值和函数的陡峭
     */
    pdf: function(x, m, s) {
      return Math.exp(-0.91893853320467274180 - Math.log(s) - Math.pow(x - m, 2) / (2 *s*s));
    },

    // 清空DOM,以及一些没必要对象
    clearMask: function() {
      this.maskEle.remove();
      this.maskEle = $('<div></div>').attr({id: 'maskEle_' + this.scene.id});
      this.context = null;
      this.isInit = false;
    }
  }

  var statics = {
  }

  if (root.AnimEditor) {
    root.AnimEditor.extendScenesEffect('TvNoise', con, methods, statics);
    return;
  }

  return function (AnimEditor) {
    AnimEditor.extendScenesEffect('TvNoise', con, methods, statics);
  }
});


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-tv-noise.js
// module id = Bade
// module chunks = 16